module.exports = __webpack_public_path__ + "assets/img/healthcareSolutions-follow.e9f00b38.png";